import { useState } from 'react';
import { Message, Icon } from 'semantic-ui-react';
import ErrorDisplay from '../ErrorDisplay/ErrorDisplay';
import { Link } from 'react-router-dom';
import { useEffect } from 'react';
const MurphyStatusDisplay = ({ videoStatus, error, loadNewAssessment }) => {
    const [newAssessmentLoaded, setNewAssessmentLoaded] = useState(false);

    useEffect(() => {
        if (videoStatus === 'graded') {
            loadNewAssessment().then(() => {
                setNewAssessmentLoaded(true);
            });
        } else {
            setNewAssessmentLoaded(false);
        }
    }, [videoStatus, loadNewAssessment]);

    if (error === 'permanently_failed') {
        return <ErrorDisplay message="Murphy was unable to grade this practice session. Please try recording again. If the issue persists, contact support." />;
    }

    if (error) {
        return <ErrorDisplay message="Murphy is taking longer than usual to grade your practice. Your video has been saved and Murphy will continue working on it. Please check back shortly for your feedback." />;
    }

    if (!videoStatus) {
        return null;
    }

    let message = '';

    if (videoStatus === 'loading') {
        message = 'Murphy is preparing new questions from your document...';
    } else if (videoStatus === 'uploading') {
        message = 'Uploading Video...';
    } else if (videoStatus === 'transcribing') {
        message = 'Your video is currently being transcribed.  This can take several minutes.';
    } else if (videoStatus === 'grading' || (videoStatus === 'graded' && !newAssessmentLoaded)) {
        message = 'Murphy is now grading your video.';
    } else if (videoStatus === 'graded' && newAssessmentLoaded) {
        message = <>
            Murphy is all finished.  You can view your report{' '}
            <Link to="/my-assessments-report" style={{ textDecoration: 'underline', fontWeight: 'bold', color: '#06718f' }}>here</Link>.
        </>;
    }

    return (
        <div className="murphy-status">
            {videoStatus !== 'graded' && videoStatus !== '' && (
                <div className="loading-icon">
                    <Icon name='circle notched' loading />
                </div>
            )}
            <div className="status-content">
                <div className="status-message">{message}</div>
            </div>
        </div>
    );
};

export default MurphyStatusDisplay;